<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="video_name"
        class="form-control-label">Name</label>
        <input
          required
          id="video_name"
          v-model="item.name"
          :class="['form-control', !isValid('name') ? 'is-invalid' : 'is-valid']"
          type="text"
          maxlength="70"
          placeholder="">
          <small id="inputHelp" class="form-text text-muted">Maximum number of characters is 70</small>
      <div
        v-if="!isValid('name')"
        class="invalid-feedback">{{ violations.name }}</div>
    </div>
    <div class="form-group">
      <label
        for="video_created"
        class="form-control-label">Created</label>
        <!-- <input
          id="video_created"
          v-model="item.created"
          :class="['form-control', !isValid('created') ? 'is-invalid' : 'is-valid']"
          type="dateTime"
          placeholder=""> -->
          <date-picker value-type="YYYY-MM-DD" :required="true" id="video_created" class="w-100" :placeholder="createdDate" :default-value="item.created" v-model="item.created" type="date"></date-picker>
      <div
        v-if="!isValid('created')"
        class="invalid-feedback">{{ violations.created }}</div>
    </div>
    <div class="form-group">
      <label
        for="video_youtubeVideoId"
        class="form-control-label">Youtube video id</label>
        <input
          required
          id="video_youtubeVideoId"
          v-model="item.youtubeVideoId"
          :class="['form-control', !isValid('youtubeVideoId') ? 'is-invalid' : 'is-valid']"
          type="text"
          placeholder="">
      <div
        v-if="!isValid('youtubeVideoId')"
        class="invalid-feedback">{{ violations.youtubeVideoId }}</div>
    </div>
    <div class="form-group">
      <label
        for="video_speaker"
        class="form-control-label">Speaker</label>
        <select
          v-model="item.speaker"
          id="video_speaker"
          class="form-control"
        >
          <option v-for="selectItem in speakerSelectItems"
                  :key="selectItem['@id']"
                  :value="selectItem['@id']"                  
                  :selected="isSelected('speaker', selectItem['@id'])">
          {{ selectItem['name'] }}</option>
        </select>
      <div
        v-if="!isValid('speaker')"
        class="invalid-feedback">{{ violations.speaker }}</div>
    </div>
    <!-- <div class="form-group">
      <label
        for="video_testimonials"
        class="form-control-label">testimonials</label>
        <select
          v-model="item.testimonials"
          id="video_testimonials"
          multiple
          class="form-control"
        >
          <option v-for="selectItem in testimonialsSelectItems"
                  :key="selectItem['@id']"
                  :value="selectItem['@id']"
                  :selected="isSelected('testimonials', selectItem['@id'])">{{ selectItem.name }}
          </option>
        </select>
      <div
        v-if="!isValid('testimonials')"
        class="invalid-feedback">{{ violations.testimonials }}</div>
    </div> -->

    <button
      type="submit"
      class="btn btn-success">Submit</button>
  </form>
</template>

<script>  
  import apiUrl from '../../store/modules/links/links';
  import { find, get, isUndefined } from 'lodash';
  import { mapFields } from 'vuex-map-fields';
  import { mapActions } from 'vuex';
  import moment from 'moment';

  export default {
    data() {
      return {
        createdDate: '',        
      }
    },
  props: {
    handleSubmit: {
      type: Function,
      required: true,
    },

    values: {
      type: Object,
      required: true,
    },

    errors: {
      type: Object,
      default: () => {},
    },

    initialValues: {
      type: Object,
      default: () => {},
    }
  },

  created() {   
    // console.log(this.item);
    if (this.item.created != null) {
      this.createdDate = moment(this.item.created).format("Y-MM-DD");  
    } else {
      // this.item.created = moment().format("Y-MM-DD");
      // this.createdDate = '';
    }  

    if (this.item.speaker != null) {
      this.item.speaker = this.item.speaker['@id'];
    } 
  },

  mounted() {
    // this.testimonialsGetSelectItems();
    this.speakersGetSelectItems();    
    this.speakersGetAllSelectedItems();
  },  
  computed: {
    // ...mapFields('testimonials/list', {
    //   'testimonialsSelectItems': 'selectItems',
    // }),   
    ...mapFields('speaker/list', {
      'speakerSelectItems': 'selectItems',
    }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    violations() {
      return this.errors || {};
    },
  },

  methods: {
    ...mapActions({
      speakersGetSelectItems: 'speaker/list/getSelectItems',
      speakersGetAllSelectedItems: 'speaker/list/getAllSelectedItems',   
        // testimonialsGetSelectItems: 'testimonials/list/getSelectItems',
    }),

    isSelected(collection, id) {
      return find(this.item[collection], ['@id', id]) !== undefined;
    },

    isValid(key) {
      return isUndefined(get(this.violations, key));
    },  
  },
};
</script>
<style lang="scss">
  .mx-input {
    border: 1px solid #28a745;
    color: #495057;
    &:hover {
      border-color: #28a745;      
    }
    &:focus {
      border-color: #28a745;
      box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
    }
  }
  .mx-icon-calendar {
    color: #28a745;
  }
</style>



// WEBPACK FOOTER //
// src/components/video/Form.vue